import { render, staticRenderFns } from "./gift_card_task.vue?vue&type=template&id=a27fbe8a&scoped=true"
import script from "./gift_card_task.vue?vue&type=script&lang=js"
export * from "./gift_card_task.vue?vue&type=script&lang=js"
import style0 from "./gift_card_task.vue?vue&type=style&index=0&id=a27fbe8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27fbe8a",
  null
  
)

export default component.exports